import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectSegmentsDomain = (state) => state.get("segments", initialState)

export const makeSelectVariables = () =>
  createSelector(selectSegmentsDomain, (state) => state.get("variables"))

export const makeSelectIsLoadingVariables = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isLoadingVariables")
  )
export const makeSelectIsDownloading = () =>
  createSelector(selectSegmentsDomain, (state) => state.get("isDownloading"))

export const makeSelectImportUpload = () =>
  createSelector(selectSegmentsDomain, (state) => state.get("importUpload"))

export const makeSelectGroups = () =>
  createSelector(selectSegmentsDomain, (state) => state.get("groups"))

export const makeSelectIsLoadingGroups = () =>
  createSelector(selectSegmentsDomain, (state) => state.get("isLoadingGroups"))

export const makeSelectIsLoadingCreateSegment = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isLoadingCreateSegment")
  )

export const makeSelectIsErrorCreateSegment = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isErrorCreateSegment")
  )

export const makeSelectIsLoadingUpdateSegment = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isLoadingUpdateSegment")
  )

export const makeSelectIsErrorUpdateSegment = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isErrorUpdateSegment")
  )

export const makeSelectIsLoadingDeleteSegment = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isLoadingDeleteSegment")
  )

export const makeSelectIsErrorDeleteSegment = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isErrorDeleteSegment")
  )

export const makeSelectListSegments = () =>
  createSelector(selectSegmentsDomain, (state) => state.get("segments"))

export const makeSelectIsLoadingSegments = () =>
  createSelector(selectSegmentsDomain, (state) =>
    state.get("isLoadingSegments")
  )

const makeSelectSegments = () =>
  createSelector(selectSegmentsDomain, (substate) => substate.toJS())

export default makeSelectSegments
export { selectSegmentsDomain }
